import { createSlice } from '@reduxjs/toolkit'

interface Forgot2FAState {
  email: string | null
  callForgot2FA: boolean
  callForgotPin: boolean
  callToggle2FA: boolean
  callTogglePin: boolean
}

const initialState: Forgot2FAState = {
  email: null,
  callForgot2FA: false,
  callForgotPin: false,
  callToggle2FA: false,
  callTogglePin: false
}

export const forgot2FASlice = createSlice({
  name: 'forgot2fa',
  initialState,
  reducers: {
    setEmail: (state, action) => {
      state.email = action.payload
    },
    setCallForgot2FA: (state, action) => {
      state.callForgot2FA = action.payload
    },
    setCallForgotPin: (state, action) => {
      state.callForgotPin = action.payload
    },
    setCallToggle2FA: (state, action) => {
      state.callToggle2FA = action.payload
    },
    setCallTogglePin: (state, action) => {
      state.callTogglePin = action.payload
    },
    clearEmail: state => {
      state.email = null
    },
    reset2FA: state => {
      state.email = null
      state.callForgot2FA = false
    }
  }
})

export const {
  setEmail,
  clearEmail,
  setCallForgot2FA,
  setCallForgotPin,
  setCallToggle2FA,
  setCallTogglePin,
  reset2FA
} = forgot2FASlice.actions

export default forgot2FASlice.reducer
